import { Alert } from '@libs/ui/ds'
import { useComponentsTranslation } from '@libs/utils/translations'
import { parseError } from '@spa/services/formErrors'
import React from 'react'
import type { FC } from 'react'

import type { RawError } from './types'

type Props = {
  rawError?: RawError
  className?: string
}

/**
 * @deprecated Use `AlertErrorAdapter` or `Alert` from `@libs/ui/ds` instead
 */
export const FormError: FC<Props> = ({ rawError, className }) => {
  const { t, tForms } = useComponentsTranslation()

  if (!rawError) {
    return null
  }

  const renderSingleError = (key: string) => (
    <Alert
      data-testid='alert-form-error'
      intent='semantic.red'
      title={t('components.errorPage.formError.singleTitle')}
      className={className}
    >
      {tForms(key)}
    </Alert>
  )

  const renderMultipleErrors = (keys: string[]) => (
    <Alert
      data-testid='alert-form-error'
      intent='semantic.red'
      title={t('components.errorPage.formError.pluralTitle')}
      className={className}
    >
      <ul>
        {keys.map((key, index) => (
          <li key={`error-${index}`} className='list-inside list-disc'>
            {tForms(key)}
          </li>
        ))}
      </ul>
    </Alert>
  )

  const errorKeys = parseError(rawError?.error)

  return errorKeys?.length === 1
    ? renderSingleError(errorKeys?.[0])
    : renderMultipleErrors(errorKeys)
}
